<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_731_92562)">
      <rect
        x="6"
        y="4"
        width="48"
        height="48"
        rx="24"
        fill="url(#paint0_radial_731_92562)"
      />
      <g filter="url(#filter1_di_731_92562)">
        <path
          d="M29.7236 16.1763C23.0603 16.3389 17.7769 21.1847 17.8764 27.0181C18.1156
          32.9646 23.0805 37.8578 29.7502 39.354C30.2825 39.4206 30.9395 39.5445 31.6501
          39.6792C32.592 39.7935 33.5592 39.8461 34.5457 39.8221C34.7895 39.8161 35.032
          39.8054 35.273 39.7903C35.79 39.758 36.2679 39.4121 36.0635 38.9954C35.9914
          38.8484 35.8821 38.7017 35.7333 38.5639C34.8736 37.7682 35.2483 36.4351 36.3173
          35.8569C39.8831 33.9284 42.2239 30.4387 42.1221 26.5107C41.97 20.6398 36.419 16.0129 29.7236 16.1763Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_731_92562"
        x="0"
        y="0"
        width="60"
        height="60"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.101961 0 0 0 0 0.392157 0 0 0 0 0.831373 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_731_92562"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_731_92562"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_731_92562"
        x="13.875"
        y="14.1721"
        width="32.25"
        height="31.6558"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.67451 0 0 0 0 0.992157 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_731_92562"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_731_92562"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.412109 0 0 0 0 0.715537 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_731_92562"
        />
      </filter>
      <radialGradient
        id="paint0_radial_731_92562"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.3842 51.34) rotate(-89.1963) scale(10.7084 61.6941)"
      >
        <stop
          offset="0"
          stop-color="#528EE9"
        />
        <stop
          offset="1"
          stop-color="#145ECE"
        />
      </radialGradient>
    </defs>
  </svg>
</template>